import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

export type ModeBannerPillProps = {
	label: ReactNode
	href?: string
	children?: ReactNode
}

export function ModeBannerPill({ label, href, children }: ModeBannerPillProps) {
	const labelClassName =
		'text-black/90 tracking-widest uppercase text-[10px] font-medium px-5 py-1.5 flex items-center'

	return (
		<div className="flex items-stretch bg-amber-200 [border-radius:8px_8px_0px_0px] overflow-hidden">
			{href
				? (
					<a
						className={`${labelClassName} hover:underline`}
						target="_blank"
						rel="noopener noreferrer"
						href={href}
					>
						{label}
					</a>
				)
				: <span className={labelClassName}>{label}</span>}
			{children}
		</div>
	)
}

export function ModeBannerRow({ children }: { children: ReactNode }) {
	return createPortal(
		<div data-mode-banner-row className="fixed bottom-0 left-1/2 -translate-x-1/2 flex items-stretch gap-1 z-30">
			{children}
		</div>,
		document.body,
	)
}
